import { ActionIcon } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { MonthCalendar } from 'src/Components/Calendars/MonthCalendar';
import useFormatDateRange from 'src/Hooks/CalendarLogic/useFormatDateRange';
import useFetchExportedEvents from 'src/Hooks/Queries/useFetchExportedEvents';
import useIsMobile from 'src/Hooks/Shared/useIsMobile';

import styles from './ExportPlanningPage.module.scss';
import { Props } from './ExportPlanningPage.types';

const ExportPlanningPage = ({ token }: Props) => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const { data } = useFetchExportedEvents({
    token,
    startDate: selectedDate.startOf('month').add(-1, 'week'),
    endDate: selectedDate.endOf('month').add(1, 'week'),
  });

  const changeDate = useCallback((direction: 'prev' | 'next') => {
    setSelectedDate(date => {
      return direction === 'next' ? date.add(1, 'month') : date.subtract(1, 'month');
    });
  }, []);

  const isMobile = useIsMobile();

  const formattedDateRange = useFormatDateRange({
    date: selectedDate,
    rangeType: 'month',
    compact: isMobile ?? false,
  });

  return (
    <div className={styles.container}>
      <div className={styles.topLine}>
        <div className={styles.dateSelectionLine}>
          <ActionIcon variant="subtle" size="xl" onClick={() => changeDate('prev')}>
            <IconChevronLeft size={24} className={styles.chevronIcon} />
          </ActionIcon>
          <ActionIcon variant="subtle" size="xl" onClick={() => changeDate('next')}>
            <IconChevronRight size={24} className={styles.chevronIcon} />
          </ActionIcon>
          <div className={styles.currentDate}>{formattedDateRange}</div>
        </div>
      </div>
      <MonthCalendar selectedDate={selectedDate} events={data} />
      <Outlet />
    </div>
  );
};

export default ExportPlanningPage;
